import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

interface CedulaPasoProps {
  cedula: string;
  onCedulaChange: (cedula: string) => void;
}

const CedulaPaso: React.FC<CedulaPasoProps> = ({ cedula, onCedulaChange }) => {
  return (
    <Card className='pb-1'>
      <CardHeader className='pb-1'>
        <CardTitle>Paso 2: Tu número de cédula</CardTitle>
        <CardDescription>Ahora, por favor ingresa tu número de cédula sin guiones ni espacios.</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="space-y-1">
            <Label htmlFor="cedula">Tu número de Cédula</Label>
            <Input
              id="cedula"
              type="number"
              placeholder="Ej: 123456789"
              value={cedula}
              onChange={(e) => onCedulaChange(e.target.value)}
              required
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default CedulaPaso;
